import { CareGapAlgorithm } from 'primary-schema';

import { Text } from 'common';

import { BlockAutocomplete } from '../../ConfigFields/Autocomplete';
import { ParentBlockSelectField } from '../../ConfigFields/SelectField';
import { COMMON_HELPER_MESSAGES } from '../constants';

const CARE_GAP_ALGORITHMS = Object.values(CareGapAlgorithm);

export function CareGapFormFields() {
  return (
    <>
      <BlockAutocomplete
        fieldName="config.algorithm"
        label="Algorithm"
        options={CARE_GAP_ALGORITHMS}
        helperText="The care gap measure against which to run to determine if the measure is open or closed."
      />
      <Text variant="heading5" bold>
        Payload
      </Text>
      <ParentBlockSelectField
        fieldName="config.payload.documents.sourceBlockName"
        label="Documents"
        required
        helperText={COMMON_HELPER_MESSAGES.documentSource}
      />
      <ParentBlockSelectField
        fieldName="config.payload.problems.sourceBlockName"
        label="Problems"
        required
        helperText={COMMON_HELPER_MESSAGES.problemsSource}
      />
      <ParentBlockSelectField
        fieldName="config.payload.medications.sourceBlockName"
        label="Medications"
        required
        helperText={COMMON_HELPER_MESSAGES.medicationsSource}
      />
      <ParentBlockSelectField
        fieldName="config.payload.labValues.sourceBlockName"
        label="Lab Values"
        required
        helperText={COMMON_HELPER_MESSAGES.labValuesSource}
      />
      <ParentBlockSelectField
        fieldName="config.payload.procedures.sourceBlockName"
        label="Procedures"
        required
        helperText={COMMON_HELPER_MESSAGES.proceduresSource}
      />
    </>
  );
}
